// extracted by mini-css-extract-plugin
export default {"segment":"Gd59579"};